<template>
  <div class="main">
    <Breadcrumb :options="breadcrumb" />

    <Wxts :wxtsList="wxtsList" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #monthTab>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="默认当月" name="1"></el-tab-pane>
          <el-tab-pane label="上月" name="2"></el-tab-pane>
        </el-tabs>
      </template>
      <!-- 导出按钮 -->
      <template #end>
        <el-form-item class="endBtn">
          <el-button type="primary" icon="el-icon-download" @click="Export(`车队运营统计表`)">导出</el-button>
        </el-form-item>
      </template>
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :btns="btns" :page="page" :limit="limit" :total="total"
      :getTotal="getTotal" :showTotal="true" :showIndex="true" @onSelectionChange="onSelectionChange"
      @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">
      <template slot="profit_rate" slot-scope="params">
        <span>{{ params.params.profit_rate }}%</span>
      </template>
      <template slot="cost_rate" slot-scope="params">
        <span>{{ params.params.cost_rate }}%</span>
      </template>
      <template slot="cartarget" slot-scope="params">
        <span>{{ params.params.cartarget }}%</span>
      </template>
      <template slot="profit_difference" slot-scope="params">
        <span>{{ params.params.profit_difference }}%</span>
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
import Wxts from '../../../components/Wxts.vue';

export default {
  mixins: [tableMixin],
  components: { Wxts },
  data() {
    return {
      activeName: '1',
      baseUrl: 'cockpit',
      getListUrl: 'runcount',
      breadcrumb: [
        { name: "财务管理" },
        { name: "车队运营统计表" },
      ],
      wxtsList: [
        {
          name: '运费总额：公司运费，不扣除任何费用，公司运费=卸货量×公司单价；'
        },
        {
          name: '营业成本：营业成本=司机工资+押运员工资+出车费用+固定费用+维保费用+附加费用+ 亏吨金额+利润奖金-运单补差；'
        },
        {
          name: '营业成本率：营业成本率=营业成本÷公司运费；'
        },
        {
          name: '净利润：来源车队利润表；'
        },
        {
          name: '净利率：净利额÷公司运费；'
        },
        {
          name: '运费达成率：运费达成率=公司运费÷本月目标额；'
        },
        {
          name: '综合油耗：加油升数合计÷当月行驶里程数×100。'
        },
      ],
      formInline: {
        fleet: null,
      },
      formCtrl: [
        {
          ...this.ctrls.fleet,
          label: "车队长",
          placeholder: "",
          options: [],
        },
        {
          label: "月份",
          keyName: "month",
          type: "month",
          // type: "monthrange",
          placeholder: "请选择月份",
          options: [],
        },
      ],
      cols: [
        { keyName: "license", label: "车牌号", minwidth: 100 },
        { keyName: "driver", label: "司机姓名", minwidth: 110 },
        { keyName: "freight", label: "运费总额", align: 'right', className: 'pr30', sortable: true, minwidth: 130 },
        { keyName: "cost", label: "营业成本", align: 'right', className: 'pr30', sortable: true, minwidth: 140 },
        { keyName: "cost_rate", label: "营业成本率", align: 'right', className: 'pr30', sortable: true, slot: 'cost_rate', minwidth: 140 },
        { keyName: "profit", label: "净利润", align: 'right', className: 'pr30', sortable: true, minwidth: 130 },
        { keyName: "profit_rate", label: "净利率", align: 'right', className: 'pr30', sortable: true, slot: 'profit_rate', minwidth: 130 },
        { keyName: "cartarget", label: "运费达成率", align: 'right', className: 'pr30', sortable: true, slot: 'cartarget', minwidth: 140 },
        { keyName: "profit_difference", label: "净利达成率", align: 'right', className: 'pr30', sortable: true, slot: 'profit_difference', minwidth: 140 },
        { keyName: "volume", label: "加油升数", align: 'right', className: 'pr30', sortable: true, minwidth: 130 },
        { keyName: "mileage", label: "行驶里程", align: 'right', className: 'pr30', sortable: true, minwidth: 130 },
        { keyName: "fuel", label: "综合油耗", align: 'right', className: 'pr30', sortable: true, minwidth: 130 },
      ],
      getTotalProperty: ['freight', 'cost', 'profit'],
      baseParams: ['month'],
    };
  },
  methods: {
    setCtrlOption(v, team, key1, key2) {
      v.options = [
        { label: '全部', value: null },
      ]
      team.map(c => {
        v.options.push({
          label: c[key1 || 'name'],
          value: c[key2 || 'id'],
        })
      })
    },
    handleClick() {
      // console.log(this.activeName)
      if (this.activeName == 2) {
        this.formInline.month = this.LAST_MONTH
      } else {
        this.formInline.month = this.CURR_MONTH
      }
      this.getList();
    },
  },
  created() {
    const { user_group_id, id } = this.user
    if (user_group_id == 5) {
      this.formInline.fleet = id
      this.formCtrl.splice(0, 1)
      this.baseParams.push('fleet')
    }
    this.MONTH = this.CURR_MONTH
    this.$set(this.formInline, 'month', this.CURR_MONTH)
  },
  mounted() {
    this.getFleet();
    this.getList()
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-tabs {
  width: 172px;
  float: left;
  margin-right: 40px;

  .el-tabs__nav-wrap {
    border: 1px solid #2691FF;
    border-radius: 3px;
    padding: 0;

    .el-tabs__nav-next,
    .el-tabs__nav-prev {
      display: none;
    }

    .el-tabs__item {
      width: 85px;
      padding: 0;
      text-align: center;
      color: #2691FF;

      &.is-active {
        color: #fff;
        background: #2691FF;
      }
    }
  }
}

/deep/ .el-tabs__nav-wrap::after {
  height: 0;
}

/deep/ .el-tabs__active-bar {
  height: 0;
}
</style>
